import { FC, ReactNode } from "react";

import { showConfirmationModal } from "mds/components/Modal";
/**
 * When an AI action generates changes for a page, we want to show a modal
 * that shows the changes side by side with the original page.
 *
 * TODO: This is mostly unstyled right now, we could add some common styling for all the AI
 * change modals here.
 */
export const showChangeModal = (
  left: ReactNode,
  right: ReactNode,
  Wrapper?: FC<{ children: ReactNode }>,
) => {
  const contents = (
    <div className="flex max-h-[70vh] w-full flex-row gap-4 overflow-y-auto">
      <div className="flex w-full flex-col gap-4">
        <h4>Current:</h4>
        {left}
      </div>
      <div className="flex w-full flex-col gap-4">
        <h4>Suggested:</h4>
        {right}
      </div>
    </div>
  );
  if (Wrapper) {
    return showConfirmationModal<boolean>({
      fullScreen: true,
      children: () => <Wrapper>{contents}</Wrapper>,
    });
  }
  return showConfirmationModal<boolean>({
    fullScreen: true,
    children: () => contents,
  });
};
